import React from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import { cx } from '@emotion/css';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';

import MedalBronze from '../images/MedalBronze.png';
import MedalGold from '../images/MedalGold.png';
import MedalNewbie from '../images/MedalNewbie.png';
import MedalSilver from '../images/MedalSilver.png';
import MedalVip from '../images/MedalVip.png';

export const BottomSheetMileageGradeContent: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <div
      css={css`
        padding-bottom: 42px;
        .drawer-title {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 54px;
          color: ${vars.v3Color.gray950};
        }
        .drawer-content-wrapper {
          overflow-y: auto;
        }
      `}
    >
      <div className={cx('drawer-title', Typography.BODY_18_SEMIBOLD)}>등급별 마일리지 적립률</div>
      <div className='drawer-content-wrapper'>
        <MileageGradeTable>
          <thead>
            <tr className={Typography.BODY_14_SEMIBOLD}>
              <th>등급</th>
              <th>적립률</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <Flex>
                  <Badge src={MedalVip} alt='vip 뱃지 아이콘' />
                  <span>VIP</span>
                </Flex>
              </td>
              <td>3%</td>
            </tr>
            <tr>
              <td>
                <Flex>
                  <Badge src={MedalGold} alt='gold 뱃지 아이콘' />
                  <span>GOLD</span>
                </Flex>
              </td>
              <td>2%</td>
            </tr>
            <tr>
              <td>
                <Flex>
                  <Badge src={MedalSilver} alt='silver 뱃지 아이콘' />
                  <span>SILVER</span>
                </Flex>
              </td>
              <td>1.5%</td>
            </tr>
            <tr>
              <td>
                <Flex>
                  <Badge src={MedalBronze} alt='bronze 뱃지 아이콘' />
                  <span>BRONZE</span>
                </Flex>
              </td>
              <td>1%</td>
            </tr>
            <tr>
              <td>
                <Flex>
                  <Badge src={MedalNewbie} alt='newbie 뱃지 아이콘' />
                  <span>NEWBIE</span>
                </Flex>
              </td>
              <td>0.5%</td>
            </tr>
          </tbody>
        </MileageGradeTable>

        <PortalTextList className={Typography.BODY_13_REGULAR}>
          <PortalText>
            <Middot />
            마일리지는 구매 확정 시 지급되며 1M=1원으로 사용 가능합니다.
          </PortalText>
          <PortalText>
            <Middot />
            마일리지는 적립 대상 스토어 상품에 한해 제공됩니다.
          </PortalText>
          <PortalText style={{ lineHeight: '140%' }}>
            <Middot />
            1,000M 이상 보유 시 100M부터 사용 가능하며, 총 상품 금액의 3%만 사용할 수 있습니다.
          </PortalText>
        </PortalTextList>
      </div>
    </div>
  );
};

const MileageGradeTable = styled.table`
  margin: 0 0 12px 0;
  width: 100%;
  border-collapse: collapse;
  td {
    width: 50%;
  }
  thead tr {
    height: 41px;
    background-color: ${vars.v3Color.gray100};

    th {
      color: #202327;
      font-weight: 600;
    }
  }
  tbody tr {
    height: 49px;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    color: ${vars.v3Color.gray900};
    border-bottom: 1px solid ${vars.v3Color.gray100};
  }
`;

const Flex = styled.div`
  margin: auto;
  width: 91px;
  display: flex;
  align-items: center;
  span {
    margin: 0 0 0 8px;
  }
`;

const PortalTextList = styled.div`
  color: ${vars.v3Color.gray500};
`;

const PortalText = styled.div`
  margin: 6px 0 0 0;
  display: flex;
`;

const Middot = styled.div`
  margin: 7px 5px 0 0;
  min-width: 2px;
  width: 2px;
  min-height: 2px;
  height: 2px;
  border-radius: 50%;
  background-color: ${vars.v3Color.gray500};
`;

const Badge = styled.img`
  width: 28px;
  height: 28px;
`;
